import { Stack } from "@mui/material"
import { CancelModel } from "./CancelModal"
import { SaveModel } from "./SaveModal"
import { useCrudForm } from "../../api/useCrudForm"
import { UseFormHandleSubmit } from "react-hook-form"
import { toast } from "react-toastify"
import React from "react"

export const ModalFooter = (
    { handleSubmit, endpoint, handleModalClose, selectedItem, cancelMessage, onError, onSuccess, editEndpoint }
        : {
            handleSubmit: UseFormHandleSubmit<any, undefined>,
            endpoint: string, onSuccess: (values: any, id?: number) => void,
            onError: (err: any) => void,
            handleModalClose: () => void,
            selectedItem: any,
            cancelMessage: string,
            editEndpoint?: string
        }) => {
    const [isLoading, setIsLoading] = React.useState(false)
    const { add, edit } = useCrudForm()


    const onSubmit = (values: any) => {
        setIsLoading(true)
        if (values.id) {
            edit({
                endpoints: editEndpoint ?? endpoint,
                onSuccess: (data: any) => {
                    onSuccess(values)
                    toast.success(data.message, { style: { background: '#3150A1' } })
                    setIsLoading(false)
                },
                onError: (error: any) => {
                    onError(error)
                    setIsLoading(false)
                },
                values: values
            })
        } else {
            setIsLoading(true)
            add({
                endpoints: endpoint,
                onSuccess: (data: any) => {
                    onSuccess(values, data.data)
                    toast.success(data.message, { style: { background: '#3150A1' } })
                    setIsLoading(false)
                },
                onError: (error: any) => {
                    onError(error)
                    setIsLoading(false)
                },
                values: values
            })
        }

    }

    return (
        <>
            <Stack direction='row' justifyContent='flex-end' spacing={3} mt={5}>
                <CancelModel handleModalClose={handleModalClose} message={cancelMessage} />
                <SaveModel onSubmit={handleSubmit(onSubmit)} selectedItem={selectedItem} isLoading={isLoading} />
            </Stack>
        </>
    )
}